<a class="link-pdf" *ngIf="item" [href]="item.file.data.attributes.url" target="_blank">
  <div class="link-pdf-content">
  <span class='link' >
    {{ item.file.data.attributes.name }}
  </span>
  <span class="link-info">{{item.file.data.attributes.ext}} {{item.file.data.attributes.size}}Ko</span>
  </div>
</a>
